const searchBarInit = () => {
  const search : HTMLElement = document.querySelector('.header__search');
  const searchBar : HTMLElement = document.querySelector('.searchbar');
  const searchActive : string = 'header__search--active';
  const close : HTMLElement = document.querySelector('.searchbar__close');
  const display: string = 'd-none';

  search.addEventListener('click', () => {
    search.classList.toggle(searchActive);
    searchBar.classList.toggle(display);
  });

  close.addEventListener('click', () => {
    search.classList.toggle(searchActive);
    searchBar.classList.toggle(display);
  });
};

export default searchBarInit;
